import { Component, ElementRef, ViewChild } from '@angular/core';
import { map, takeUntil, tap } from "rxjs";
import { DocumentReviewValidationStatus } from "@enums/document-review-validation-status.enum";
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { ReviewManager } from "@managers/review.manager";
import { BaseComponent } from "../../../base.component";
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';
import { ReviewEntry } from '@models/ui/review-entry.model';
import { DocViewerContextPanelAnimations } from '../doc-viewer-context-panel.animations';

@Component({
    selector: 'lex-review-context-panel',
    templateUrl: './review-context-panel.component.html',
    styleUrls: ['./review-context-panel.component.scss'],
    animations: DocViewerContextPanelAnimations,
    standalone: false
})
export class ReviewContextPanelComponent extends BaseComponent {
	
	@ViewChild('docContainer') public docContainer: ElementRef;
	public pointerDocId: string = '';
	public panelState: 'expanded' | 'collapsed' = 'expanded';
	public panelExpandWidth: number = 310;
	public panelCollapseWidth: number = 55;
	public maxAnimationWidth: string;
	public isAnimationDisabled: boolean = true;

	public reviewDocs$: any = this.docViewerStore.simpleState$.pipe(
		map((state) => {
			return state.reviewDocs
				?.map((doc, _, collection) => {
					const hasParentInView = collection.some((docFromCollection) => docFromCollection.docId === doc.emailParentId);
					doc.relationship = hasParentInView ? doc.relationship : 'standalone';
					return doc;
				});
		}),
		tap((x) => {
			this.currentlyCheckedOutDocumentId = x?.find((doc) => !doc.hasBeenReviewed)?.docId;
		})
	);

	public currentDocumentId: string;
	public currentlyCheckedOutDocumentId: string;
	public resumeButtonState: 'visible' | 'hidden' = 'hidden';

	public showValiationMessageReviewDocId: string = '';

	get ValidationStatus(): typeof DocumentReviewValidationStatus {
		return DocumentReviewValidationStatus;
	}

	constructor(
		private docViewerStore: DocViewerStore,
		private reviewManager: ReviewManager
	) {
		super();
		this.docViewerStore.currentDocument$.pipe(
			takeUntil(this.destroy$)
		).subscribe((currentDocument) => {
			this.currentDocumentId = currentDocument.docId;
			this.resumeButtonState = (this.currentDocumentId !== this.currentlyCheckedOutDocumentId) && !!this.currentlyCheckedOutDocumentId ? 'visible' : 'hidden';
			if (this.currentDocumentId !== this.showValiationMessageReviewDocId)
				this.toggleValitaionMessage(null);
		});
	}

	public goToDocument(documentId: string) {
		this.reviewManager.continueWithoutSavingConfirmationDialog().subscribe((confirm) => {
			if (confirm)
				this.reviewManager.loadDocument(documentId);
		});
	}

	public resume(): void {
		this.reviewManager.continueWithoutSavingConfirmationDialog().subscribe((confirm) => {
			if (confirm) {
				this.reviewManager.loadDocument(this.currentlyCheckedOutDocumentId);
				this.reviewManager.contextPanelScrollIntoView(1500);
				this.toggleValitaionMessage(null);
			}
		});
	}

	public shouldShowResumeButton(): boolean {
		return this.resumeButtonState === 'visible';
	}

	public toggleValitaionMessage(requestedId: string): void {
		if (this.showValiationMessageReviewDocId === requestedId) {
			this.showValiationMessageReviewDocId = null;
			return;
		}

		this.showValiationMessageReviewDocId = requestedId;
	}

	public toDocContextDoc(doc: ReviewEntry): DocViewerContextDoc{
		const contextDoc = new DocViewerContextDoc();
		contextDoc.docId = doc.docId;
		contextDoc.docTitle = doc.documentTitle;
		contextDoc.displayType = this.relationshipToContextViewMap.get(doc.relationship);
		return contextDoc;
	}

	public trackByDocId(index: number, review: ReviewEntry): string {
		return review.docId;
	} 

	private relationshipToContextViewMap: Map<'parent' | 'child' | 'standalone','native' | 'email' | 'attachment'> =
	new Map<'parent' | 'child' | 'standalone','native' | 'email' | 'attachment'>([
		['parent', 'email'],
		['child', 'attachment'],
		['standalone','native']
	]);

}
